import { Button } from 'antd';
import Tooltip from '../common/Tooltip';
import { useEffect, useState } from "react";
import { navbarButtonStyle } from "../../utils/styles";
import { hexToRgba } from "../../utils/theme";
import { getPrimaryDark } from "../../constants/constants";
import { useStore } from "../../store/store";

export const NavbarButton = ({
  tooltipContent,
  onClick,
  disabled = false,
  hidden,
  icon,
  children,
  style,
  buttonStyle,
  active = false,
  className,
  preventDefaultOnClick = true,
  stopPropagationOnClick = true,
}) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const isTemplate = useStore(({ currentDocument }) => currentDocument?.type === 'template');
  const accentColor = getPrimaryDark(isTemplate);

  useEffect(() => {
    if (disabled) setTooltipVisible(false)
  }, [disabled])

  const buttonDisplay = (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      width: '100%',
      height: '100%',
      opacity: disabled ? 0.3 : 1,
      ...style
    }}>
      {icon}
      {!icon && children}
    </div>
  )

  return (
    <Tooltip
      open={tooltipVisible}
      placement='bottom'
      mouseLeaveDelay='0'
      title={tooltipContent}
    >
      <Button
        data-outside-ignore="true"
        disabled={disabled}
        hidden={hidden}
        onMouseEnter={() => setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}
        style={{
          ...navbarButtonStyle,
          ...(active ? {
            borderColor: accentColor,
            backgroundColor: hexToRgba(accentColor, 0.08),
          } : {}),
          ...buttonStyle
        }}
        className={className}
        onMouseDown={(e) => e.preventDefault()}
        onClick={
          disabled
            ? null
            : (e) => {
                if (preventDefaultOnClick) e.preventDefault();
                if (stopPropagationOnClick) e.stopPropagation();
                onClick?.(e);
              }
        }
      >
        {buttonDisplay}
      </Button>
    </Tooltip>
  )
}
